import React from "react";
import { useSelector } from "react-redux";
import { Button, Icon } from "semantic-ui-react";
import StatusLabels from "@common/components/shared/StatusLabels";
import SimpleInputComponent from "../forms/SimpleInputComponent";
import SimpleSelectComponent from "../forms/SimpleSelectComponent";
import SimpleToggleComponent from "../forms/SimpleToggleComponent";
import useCustomerReviewModal from "../../hooks/customerInteractionAdmin/useCustomerReviewModal";
import InteractionOptionsAction from "@common/redux/actions/InteractionOptionsAction";
import { mapToSelect } from "@common/components/helpers/forms";
import useCustomerReviewsFilters from "../../hooks/useCustomerReviewsFilters";
import useReviews from "../../hooks/useReviews";
import useCustomerSessions from "../../hooks/useCustomerSessions";
import useInteractions from "../../hooks/useInteractions";
import { DatesRangeInput } from "semantic-ui-calendar-react";
import useLogin from "../../hooks/useLogin";

export const InteractionsFilters = () => {
  const {
    customerInteractionOptions: { reasons },
  } = useSelector((state) => InteractionOptionsAction.getStatePath(state));
  const { triggeredByAlert, customerInteractionReasonId, setState } =
    useCustomerReviewsFilters();
  const [{ optionShowComplianceAlerts, isDesktop }] = useLogin();
  const desktopLoginResponse = useSelector((state) => state.logIn);
  const showComplianceAlerts = isDesktop
    ? desktopLoginResponse.optionShowComplianceAlerts
    : optionShowComplianceAlerts;

  return (
    <div className="flex-row-center gap-1" style={{ overflow: "visible" }}>
      <SimpleSelectComponent
        name="customerInteractionReasonId"
        label="Reason:"
        className="flex p-0 m-0"
        labelClassName=""
        value={customerInteractionReasonId}
        options={mapToSelect(reasons)}
        onChange={(_, { value }) => {
          setState({ customerInteractionReasonId: value });
        }}
      />
      {showComplianceAlerts && (
        <SimpleToggleComponent
          name="triggeredAlert"
          label="Triggered Alert?"
          className="flex p-0 m-0"
          labelClassName="pb-1"
          value={triggeredByAlert}
          onChange={() => setState({ triggeredByAlert: !triggeredByAlert })}
        />
      )}
    </div>
  );
};

export const CustomerSessionsFilters = () => {
  const { onInputChange } = useCustomerReviewsFilters();
  const [{ isDesktop }] = useLogin();

  const inputFields = [
    { name: "netLossFrom", label: "Net Loss (From):" },
    { name: "netLossTo", label: "Net Loss (To):" },
    { name: "durationFrom", label: "Duration (From):" },
    { name: "durationTo", label: "Duration (To):" },
    { name: "spendFrom", label: "Spend (From):" },
    { name: "spendTo", label: "Spend (To):" },
  ];

  const inputs = inputFields.map((x) => (
    <SimpleInputComponent
      name={x.name}
      label={x.label}
      className="w-10em"
      onChange={onInputChange}
      type="number"
    />
  ));

  if (isDesktop) return inputs;

  return (
    <div style={{ display: "flex", gap: "1em", flexWrap: "wrap" }}>
      {inputs}
    </div>
  );
};

export const ReviewsFilters = () => {
  const { reviewStatusCounts, onStatusChange } = useCustomerReviewsFilters();

  return (
    <div className="flex-row items-center gap-1">
      <StatusLabels labels={reviewStatusCounts} onClick={onStatusChange} />
      {/*
      Hiding these temporarily as requested by James Wheeler
      <SimpleSelectComponent
        name="type"
        label="Type:"
        options={mapToSelect(reviewTypes)}
      />
      <SimpleToggleComponent
        name="isEscalated"
        label="Escalated:"
        value={isEscalated}
        onChange={() => setState({ isEscalated: !isEscalated })}
      />*/}
    </div>
  );
};

const CustomerReviewFilters = () => {
  const { currentTab } = useCustomerReviewModal();
  const { interactionDateRange, getCustomerInteractions } = useInteractions();
  const { getCustomerSessions } = useCustomerSessions();
  const { getCustomerReviews } = useReviews();

  const {
    id,
    dateRange,
    showFilters,
    onDatesChange,
    onInputChange,
    toggleFilters,
  } = useCustomerReviewsFilters();

  const fnRefresh =
    currentTab === 2
      ? getCustomerSessions
      : currentTab === 3
        ? getCustomerReviews
        : getCustomerInteractions;

  const currentFilters = (currentTab) => {
    switch (currentTab) {
      case 1:
        return InteractionsFilters;
      case 2:
        return CustomerSessionsFilters;
      case 3:
        return ReviewsFilters;
      default:
        return <></>;
    }
  };

  const CurrentFiltersComponent = currentFilters(currentTab);

  return (
    <div className="flex-wrap gap-1">
      <div className="flex-between align-bottom">
        <SimpleInputComponent
          name="id"
          label="ID Search:"
          className="w-25"
          value={id}
          onChange={onInputChange}
        />
        <div>
          <b>Date range:</b>
          <DatesRangeInput
            name={currentTab === 1 ? "interactionDateRange" : "dateRange"}
            placeholder="From - To"
            dateFormat="YYYY-MM-DD"
            value={currentTab === 1 ? interactionDateRange : dateRange}
            iconPosition="left"
            onChange={onDatesChange}
            closable
            style={{ width: "280px" }}
          />
        </div>
        <Button positive onClick={fnRefresh}>
          Refresh
        </Button>
        <Button
          type="button"
          onClick={toggleFilters}
          color={showFilters ? "blue" : ""}
          inverted={!showFilters}
          className="w-3_5 h-3 p-0 ml-0_5 border-blue"
        >
          <Icon
            className="p-0 m-0"
            name="sliders horizontal"
            color={showFilters ? "" : "blue"}
            size="large"
          />
        </Button>
      </div>
      {showFilters && <CurrentFiltersComponent />}
    </div>
  );
};

export default CustomerReviewFilters;
